<template>
    <cs-notification
        v-if="isFirstAdditionalItem"
        data-component="FirstAdditionalItemNotification"
        :notificationState="Components.CsNotification.NotificationState.INFO"
        class="mb-24"
    >
        <template #headline>Alternative Modelle</template>
        Wir haben für dich noch weitere Modelle vom <b> Typ {{ item.bodyTypeKey }} </b> der
        <b> Marke {{ item.make }} </b> gefunden.
    </cs-notification>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { AmsItem } from '../../../services/amsSearch/amsSearch.interface'
import { CsNotification } from '@sunrise/components'
import { Components } from '@sunrise/types'
import { useAmsSearchStore } from '../../../store/amsSearch'

const store = useAmsSearchStore()

const props = defineProps({
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
})

const isFirstAdditionalItem = (() => {
    const currentItem = props.item
    const results = store.results

    if (!results) {
        return false
    }

    const previousItem =
        results.items[
            currentItem.position - // starts with 1
                1 - // because arrays start with 0
                1 // the previous
        ]

    if (previousItem) {
        return !previousItem.additionalItem && currentItem.additionalItem
    } else {
        return currentItem.additionalItem
    }
})()
</script>
